import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=3a3a6116&"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports